import { BaseApiClient } from './base-client'
import { API_ROUTES } from '../api-routes'

/**
 * Sign out request payload
 */
export interface SignOutRequest {
  sessionId: string
  returnTo?: string
}

/**
 * Sign out response
 */
export interface SignOutResponse {
  signOutUrl: string
  success: boolean
}

/**
 * Authentication API Client
 * Handles authentication-related API calls
 */
class AuthClient extends BaseApiClient {
  /**
   * Sign out user by getting WorkOS logout URL
   */
  async signOut(request: SignOutRequest): Promise<SignOutResponse> {
    return this.request<SignOutResponse>(API_ROUTES.AUTH.SIGN_OUT, {
      method: 'POST',
      body: JSON.stringify(request),
    })
  }
}

// Export singleton instance
export const authClient = new AuthClient()
